import { render, staticRenderFns } from "./userabilitymodel.vue?vue&type=template&id=946abf20&scoped=true"
import script from "./userabilitymodel.vue?vue&type=script&lang=js"
export * from "./userabilitymodel.vue?vue&type=script&lang=js"
import style0 from "./userabilitymodel.vue?vue&type=style&index=0&id=946abf20&prod&lang=less"
import style1 from "./userabilitymodel.vue?vue&type=style&index=1&id=946abf20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946abf20",
  null
  
)

export default component.exports